import { render, staticRenderFns } from "./CommercialsChart.vue?vue&type=template&id=48d97afe&scoped=true"
import script from "./CommercialsChart.vue?vue&type=script&lang=js"
export * from "./CommercialsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d97afe",
  null
  
)

export default component.exports